import { IActionItem } from '../types';

export default class ActionsState {
  actionsList: IActionItem[] = [];
}
